<template>
    <loading class="c-loader-wrapper" :active.sync="isLoading" :is-full-page="fullSize" :z-index="zIndex">
        <div class="loader-content">
            <img class="loader-icon" src="@/assets/images/loader.gif" alt="loader-icon" />
            <h4 class="loader-text">{{ text }}</h4>
        </div>
    </loading>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const props = withDefaults(
    defineProps<{
        value: boolean;
        text?: string;
        fullSize?: boolean;
        zIndex?: number;
    }>(),
    { text: 'Loading...', fullSize: true, zIndex: 99999 }
);

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
}>();

const isLoading = computed({
    get: () => props.value,
    set: (value: boolean) => emit('input', value)
});
</script>

<style lang="scss" scoped>
.c-loader-wrapper {
    &.vld-overlay {
        &.is-full-page {
            z-index: v-bind(zIndex);
        }
        .loader-content {
            text-align: center;
            .loader-icon {
                width: 25%;
                margin-bottom: 0.5rem;
            }
        }
    }
}
</style>
